// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"54eedeaf68d7a2417b42","883":"9b1ab9cf0653e7627c28"}[chunkId] + ".js";
};